/**
 * sparkly-ports.ts — this app's answers to the two questions the Sparkly engine
 * asks its host.
 *
 * The engine lives in `packages/sparkly-engine` and is shared with
 * `apps/student`. It cannot import from an app, so it declares ports and each
 * app fills them in at boot. This file is the kids side of that contract;
 * `app-main.ts` imports it for the side effect, once.
 *
 * SUBPATH IMPORTS, NOT THE PACKAGE INDEX. The index also re-exports the Zod
 * schemas, and pulling those into the boot graph cost +22 KB gz — `check-bundle`
 * caught it. These two modules are the ports and nothing else.
 */
import { setSparklyNotifier } from '@theidiomaclub/sparkly-engine/notifier';
import { setSparklySessionTokenReader } from '@theidiomaclub/sparkly-engine/session-port';
import { authService } from './auth.service';

/**
 * The engine's token reader points at this app's CACHED session. The package
 * default calls the SDK directly, which is correct but acquires an auth lock on
 * every request — on the Sparkly path that is latency the student feels.
 * `authService.getSession()` is the memory-cached read this app has always used.
 */
setSparklySessionTokenReader(async () => {
    const session = await authService.getSession();
    return session ? { access_token: session.access_token } : null;
});

/**
 * The engine reports facts, not sentences. This is where they become the
 * Spanish the student on this front reads — `apps/student` speaks English and
 * answers the same fact differently.
 * The toast module stays lazily imported so it does not re-enter the boot
 * bundle: the same shape the inline `import()` had before the engine moved out.
 */
setSparklyNotifier({
    hint: (kind) => {
        if (kind !== 'long-audio') return;
        void import('./notify.ts')
            .then(({ default: SmartNotify }) => {
                SmartNotify.info('Mensajes más cortos funcionan mejor. Intenta 1-2 frases.', 3000);
            })
            .catch(() => { /* non-critical */ });
    },
});
